import React from "react";

const About = () => {
  return (
    <div name="about" className="w-full h-screen text-gray-300">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-[#54AFE7]">
              About
            </p>
          </div>
        </div>

        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-4xl font-bold">
            <p>Hi, I'm Bhanu, nice to meet you. Please take a look around.</p>
          </div>
          <div>
            <p>
              I'm Bhanu Bansal, a final year CSE student. I am a highly
              motivated and passionate full-stack web developer with a strong
              focus on frontend development. Eager to learn and stay at the
              forefront of web technologies.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
